<template>
  <PageWrapper
    :active-section="SECTION_EXPLORE"
    :active-page="PAGE_EXPLORE_DESTINATIONS"
    align="left"
    width="full"
  >
    <SmartFeed
      :source="exploreDestinationsFeedStore"
      default-entity-size="small"
      default-feed-layout="grid"
      load-more-behavior="auto"
    />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import { PAGE_EXPLORE_DESTINATIONS, SECTION_EXPLORE } from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import SmartFeedEngine from "@/smart-feed/smart-feed-engine";

export default {
  name: "ExploreDestinations",
  components: {
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_EXPLORE,
      PAGE_EXPLORE_DESTINATIONS,
    };
  },
  computed: {
    exploreDestinationsFeedStore() {
      return SmartFeedEngine.getFeedPiniaStore("ExploreDestinationsFeedSource");
    },
  },
};
</script>
